import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="filter-dropdown"
// This controller manages dropdown filters for property leads filtering
export default class extends Controller {
  static targets = ["menu", "button", "filter"]
  static values = {
    open: { type: Boolean, default: false },
    filterParam: String
  }
  
  static outlets = ["filters"]

  connect() {
    document.addEventListener('click', this.outsideClickHandler)

    if (this.hasFilterTarget) {
      setTimeout(function(){
        this.filterInlet = this.application.getControllerForElementAndIdentifier(this.filterTarget, this.filterTarget.dataset.controller)
      }.bind(this), 100)
    }
  }

  disconnect() {
    document.removeEventListener('click', this.outsideClickHandler)
  }

  toggle() {
    this.openValue = !this.openValue
  }

  hide() {
    this.openValue = false
  }

  openValueChanged() {
    if (this.openValue) {
      this.menuTarget.classList.remove('hidden')
    } else {
      this.menuTarget.classList.add('hidden')

      if (this.hasFiltersOutlet) { // Exclude default value setting
        setTimeout(() => {
          this.filtersOutlet.applyChangesIfNeeded()
        }, 50)
      }
    }
  }
  
  // Apply changes and close dropdown
  applyChange(event) {
    event.preventDefault()
    event.stopPropagation()
    
    if (this.hasFiltersOutlet) {
      // this.filtersOutlet.hasChanged = true
      this.filtersOutlet.updateActiveFilters()
      this.filtersOutlet.submitForm()
    }
    
    this.hide()
  }
  
  // Clear filter and close dropdown
  clear(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.hasFilterTarget) {
      this.filterInlet.clear()
    }    
    // this.hide()
  }
  
  // Handle keydown events for filter inputs
  handleKeydown(event) {
    // Only handle Enter key on input elements
    if (event.key === 'Enter' && event.target.tagName === 'INPUT') {
      event.preventDefault()
      this.applyChange(event)
    }
  }

  // Handler for clicks outside the dropdown
  outsideClickHandler = (event) => {
    if (this.openValue && !this.element.contains(event.target)) {
      this.hide()
    }
  }
}
